import { ipcOn, ipcRemoveListener, ipcSend } from './electron'

/**
 * 下载单个或多个文件
 * @param urls 单个URL字符串或URL数组
 * @param options 下载选项
 */
export const downloadFiles = (
  urls: string | string[],
  options?: {
    directory?: string // 保存目录，默认为用户下载目录
    showProgressBar?: boolean // 是否显示进度条，默认为true
    openFolderWhenDone?: boolean // 下载完成后是否打开文件夹，默认为false
    saveAs?: boolean // 是否显示另存为对话框，默认为false
    onProgress?: (progress: { percent: number; transferredBytes: number; totalBytes: number }) => void // 进度回调
    onCompleted?: (item: { filename: string; path: string; fileSize: number; mimeType: string; url: string }) => void // 完成回调
  }
) => {
  // 规范化URLs为数组
  const urlsArray = Array.isArray(urls) ? urls : [urls]

  // 过滤掉无效的URL
  const validUrls = urlsArray.filter((url) => url && typeof url === 'string' && url.trim() !== '')

  if (validUrls.length === 0) {
    console.error('没有有效的URL可以下载')
    return
  }

  // 从选项中提取回调函数
  const onProgress = options?.onProgress
  const onCompleted = options?.onCompleted

  // 创建一个不包含函数的新选项对象，用于IPC传输
  const ipcOptions = {
    directory: options?.directory,
    showProgressBar: options?.showProgressBar,
    openFolderWhenDone: options?.openFolderWhenDone,
    saveAs: options?.saveAs
  }

  // 为事件监听器创建具名函数，以便于后续移除
  const progressListener = (_: any, progress: any) => {
    onProgress && onProgress(progress)
  }

  const completedListener = (_: any, item: any) => {
    onCompleted && onCompleted(item)

    // 下载完成后，清理所有事件监听器
    if (onProgress) {
      ipcRemoveListener('download-progress', progressListener)
    }
    if (onCompleted) {
      ipcRemoveListener('download-completed', completedListener)
    }
  }

  // 设置下载进度监听
  if (onProgress) {
    ipcOn('download-progress', progressListener)
  }

  // 设置下载完成监听
  if (onCompleted) {
    ipcOn('download-completed', completedListener)
  }

  // 向主进程发送下载请求，只传递可序列化的数据
  ipcSend('download-files', {
    urls: validUrls,
    options: ipcOptions
  })
}

/**
 * 专门用于下载图片的便捷方法
 * @param imageUrls 图片URL或URL数组
 * @param options 下载选项
 */
export const downloadImages = (
  imageUrls: string | string[],
  options?: {
    directory?: string
    openFolderWhenDone?: boolean
    onCompleted?: (item: { filename: string; path: string; fileSize: number; mimeType: string; url: string }) => void
  }
) => {
  return downloadFiles(imageUrls, {
    ...options,
    showProgressBar: true
  })
}
